










































































import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class CertificateQuery extends Vue {
  private rules = {
    name: [{ required: true, message: "姓名不能为空" }],
    idCard: [
      { required: true, message: "身份证号不能为空" },
      {
        pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
        message: "请输入正确的证件号",
        trigger: "blur"
      }
    ],
    captcha: [{ required: true, message: "请输入验证码" }]
  };
  private form = { name: "", idCard: "", code: "", captcha: "" };
  private startQuery() {
    // this.$message({
    //   message: "暂未开放，请在知识竞答结束后在进行查询。",
    //   type: "warning"
    // });
    // return;
    (this.$refs["ruleForm"] as any).validate(async (valid) => {
      if (valid) {
        try {
          const res = await this.$axios("queryCertificate", this.form);
          localStorage.setItem("certificate", JSON.stringify(res));
          this.$router.push({
            name: "证书",
          });
        } catch (error) {
          console.log("error submit!!");
        }
        this.refreshCode();
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  private identifyCode = "";
  async created() {
    await this.getConfig();
    await this.refreshCode();
  }
  private async refreshCode() {
    let num = ""; //定义用户编号
    for (let i = 0; i < 6; i++) {
      num += Math.floor(Math.random() * 10);
    }
    this.form.code = new Date().getTime() + num; //时间戳，用来生成用户编号。
    const res = await this.$axios("getCode", {
      code: this.form.code
    });
    this.identifyCode = res.data;
  }

  // 当前环境
  private env = "";
  // 获取 config
  private async getConfig() {
    const { data } = await this.$axios("getConfig");
    this.env = data.data.env;
  }
}
